module.exports = __webpack_public_path__ + "static/media/YF51_2.015a5ab1.jpg";